import { InventoryLocator } from "@/features/inventory/InventoryLocator";
import { NotesPanel } from "@/features/notes/NotesPanel";
import { StagingsPanel } from "@/features/stagings/StagingsPanel";
import { Box } from "@mui/material";

export function HomePage() {
  return (
    <Box sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
      <StagingsPanel />
      <InventoryLocator />
      <NotesPanel />
    </Box>
  );
}
